import React, { FC } from 'react';
import HeadComponent from '@/components/HeadComponent/HeadComponent';
import FooterComponent from '@/components/FooterComponent';
import styles from './CheckoutSuccess.module.scss';
import { useTranslation } from 'react-i18next';
// import { getParameters } from '@/utils/mainUtils';

const CheckoutSuccess: FC = () => {
  const { t } = useTranslation();
  // const params = getParameters();
  // const amount = params.amount ?? '';
  // const date = params.date ?? '';
  // const referenceId = params.referenceId ?? params.reference_id ?? '';

  return (
    <div className={styles.root}>
      <HeadComponent isHideHome />
      <div className={styles.rootContent}>
        <div className={styles.content}>
          <div className={styles.iconWrap}>
            <div className={styles.iconRing} />
            <div className={styles.iconRingInner} />
            <div className={styles.iconCircle}>
              <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles.checkIcon}>
                <path d="M14 24L21 31L34 17" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
          </div>
          <h1 className={styles.title}>{t('SUCCESS')}</h1>
          <p className={styles.subtitle}>{t('Your transaction has been processed successfully.')}</p>
          {/* Details (amount, date, reference ID) - commented out for now
          {(amount || date || referenceId) && (
            <div className={styles.details}>
              {amount && (
                <div className={styles.detailRow}>
                  <span className={styles.detailLabel}>{t('Amount')}</span>
                  <span className={styles.detailValue}>{amount}</span>
                </div>
              )}
              {date && (
                <div className={styles.detailRow}>
                  <span className={styles.detailLabel}>{t('Date')}</span>
                  <span className={styles.detailValue}>{date}</span>
                </div>
              )}
              {referenceId && (
                <div className={styles.detailRow}>
                  <span className={styles.detailLabel}>{t('Reference ID')}</span>
                  <span className={styles.detailValue}>{referenceId}</span>
                </div>
              )}
            </div>
          )}
          */}
        </div>
      </div>
      <FooterComponent />
    </div>
  );
};

export default CheckoutSuccess;
